import React from 'react';
import './InteriorDesign.css';
import useScrollToTop from './useScrollToTop';
import image2 from '../img/interior.jpg';
import ReusableLanding from './ReusableLanding';
import FAQ from './FAQ';
import homeInteriorFAQData from './homeInteriorFAQData';
import InquiryForm from './InquiryForm';
import WhyChooseUs from './WhyChooseUs.js';
import livingroomimg_better from '../img/living_room_better.png';
import office_room_small from '../img/samll_room_office_type.png';
import bedroom_upstairs from '../img/up_bedromm.png';
import kitchenimg from '../img/kitchen_img_1.jpeg';
import kitchenimg2 from '../img/kitchen_img_2.jpeg';
import kitchenimg3 from '../img/kitchen_img_3.jpeg';
import kitchenimg4 from '../img/kitchen_img_4.jpeg';
import kitchenimg5 from '../img/kitchen_img_5.jpeg';
import kitchenimg6 from '../img/kitchen_img_6.jpeg';
import kitchenimg7 from '../img/kitchen_img_7.jpg';
import kitchenimg8 from '../img/kitchen_img_8.jpg';
import hallimg from '../img/hall_img_1.jpg';
import livingroomimg1 from '../img/living_room_img_1.jpg';
import livingroomimg2 from '../img/living_room_img_2.jpg';
import livingroomimg3 from '../img/living_room_img_3.jpg';
import bedroomimg1 from '../img/room_img_1.jpg';
import bedroomimg2 from '../img/room_img_2.jpg';
import bedroomimg3 from '../img/room_img_3.jpg';
import bedroomimg4 from '../img/room_img_4.jpg';
import dinningimg from '../img/dinning_area.png';
import bathroomimg from '../img/bathroom_top.jpg';



const HomeInteriorDesign = () => {
  useScrollToTop();
  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Home Interior Design"
        description="Your home should be a reflection of your personal style and a sanctuary where you can relax and unwind. At Housekaar, we specialize in creating bespoke home interior designs that cater to your unique needs and preferences."
      />


      <div className="interior-design-page">
        <section>
          <h2>Living Room Design</h2>
          <p>
            The living room is the heart of your home, and we believe it should be both stylish and comfortable. Our designs focus on creating a harmonious balance between aesthetics and functionality. We consider factors like natural lighting, furniture placement, and color palettes to create a welcoming and inviting space.
          </p>
          <div className="room-grid"> {/* Using the new CSS class */}
            <img src={livingroomimg_better} alt="Living Room Design 1" />
            <img src={livingroomimg1} alt="Living Room Design 2" />
            <img src={livingroomimg2} alt="Living Room Design 3" />
          </div>
          <ul>
            <li>Custom furniture design and selection</li>
            <li>Lighting design to enhance ambiance</li>
            <li>Color coordination and material selection</li>
            <li>Space optimization and layout planning</li>
          </ul>
        </section>

        <section className="kitchen-section"> {/* Using the section-specific class */}
          <h2>Kitchen and Dining Area</h2>
          <p>
            The kitchen is often the hub of family life, and we design kitchens that are not only beautiful but also highly functional. We pay close attention to workflow, storage solutions, and appliance integration. Our dining area designs create a cohesive and elegant space for family meals and gatherings.
          </p>
          <div className="room-grid"> {/* Using room-grid for kitchen images as well */}
            <img src={kitchenimg} alt="Kitchen Design 1" />
            <img src={kitchenimg2} alt="Kitchen Design 2" />
            <img src={kitchenimg3} alt="Kitchen Design 3" />
            <img src={kitchenimg4} alt="Kitchen Design 4" />
            <img src={kitchenimg5} alt="Kitchen Design 5" />
            <img src={kitchenimg6} alt="Kitchen Design 6" />
          </div>
          <div className="featured-room" style={{ marginTop: '30px' }}> {/* Example of featured-room */}
            <div className="text-content">
              <h3>Elegant Dining Space</h3>
              <p>A beautifully designed dining area for family gatherings.</p>
            </div>
            <div className="featured-image-container">
              <img src={dinningimg} alt="Dining Area" className="featured-image" />
              <img src={kitchenimg7} alt="Dining Area" className="featured-image" />
              <img src={kitchenimg8} alt="Dining Area" className="featured-image" />
            </div>
          </div>
          <ul>
            <li>Ergonomic kitchen layouts</li>
            <li>Custom cabinetry and countertop selection</li>
            <li>Dining area furniture and decor</li>
            <li>Integrated appliance planning</li>
          </ul>
        </section>


        <section className="bedroom-office-section"> {/* Using the section-specific class */}
          <h2>Bedroom and Office Space</h2>
          <p>
            Your bedroom should be a personal retreat, and for many, a home office is now essential. We design bedrooms that are both luxurious and comfortable, and home office spaces that are functional and inspiring.
          </p>
          <div className="room-grid"> {/* Using room-grid */}
            <img src={bedroomimg1} alt="Bedroom Design 1" />
            <img src={bedroomimg2} alt="Bedroom Design 2" />
            <img src={office_room_small} alt="Home Office Design" />
            <img src={bedroomimg3} alt="Bedroom Design 3" />
            <img src={bedroomimg4} alt="Bedroom Design 4" />
            <img src={bedroom_upstairs} alt="Upstairs Bedroom" />
          </div>
          <ul>
            <li>Bedroom furniture and bedding selection</li>
            <li>Custom closet and storage solutions</li>
            <li>Ergonomic office furniture selection</li>
            <li>Lighting and organization for work spaces</li>
          </ul>
        </section>
        <section className="hallway-bathroom-section"> {/* Using the section-specific class */}
          <h2>Hallway and Bathroom Design</h2>
          <p>
            Hallways connect spaces and should be aesthetically pleasing. Bathrooms should be functional and can also be designed as personal retreats.
          </p>
          <div className="featured-room"> {/* Using featured-room for a single image with text */}
            <div className="text-content">
              <h3>Inviting Hallway</h3>
              <p>A well-lit and decorated hallway creates a welcoming entrance.</p>
            </div>
            <div className="featured-image-container">
              <img src={hallimg} alt="Hallway Design" className="featured-image" />
            </div>
          </div>
          <div className="featured-room" style={{ marginTop: '30px' }}> {/* Another featured-room for bathroom */}
            <div className="text-content">
              <h3>Relaxing Bathroom Retreat</h3>
              <p>Transform your bathroom into a spa-like sanctuary.</p>
            </div>
            <div className="featured-image-container">
              <img src={bathroomimg} alt="Bathroom Design" className="featured-image" />
            </div>
          </div>
          <ul>
            <li>Hallway lighting and decor</li>
            <li>Space-saving hallway solutions</li>
            <li>Bathroom fixture and tile selection</li>
            <li>Ventilation and lighting for bathrooms</li>
          </ul>
        </section>
        <section className="customization-section"> {/* Using the section-specific class */}
          <h2>Customization and Personalization</h2>
          <p>
            We understand that every home is unique, and we offer a wide range of customization options to ensure that your interior design reflects your personal style. From custom furniture and lighting to unique material selections and finishes, we work closely with you to bring your vision to life.
          </p>
          <div className="room-grid"> {/* Using room-grid */}
            <img src={livingroomimg3} alt="Custom Living Room 1" />
            <img src={bedroomimg3} alt="Custom Bedroom 1" />
            {/* You can add more customization related images here using more <img> tags */}
          </div>
        </section>
      </div>
      <WhyChooseUs />
      <InquiryForm />
      <FAQ faqData={homeInteriorFAQData} />
    </>
  );
};

export default HomeInteriorDesign;